import { inject, Injector, runInInjectionContext } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState } from '@ngrx/signals';
import {
  Energy_Village__Tipo_Feedback_Enum,
  FeedbackGQL,
} from '../../_graphql/generated';

export const init = (injector: Injector, store: any) => () => {
  return runInInjectionContext(injector, () => {
    const getter = inject(FeedbackGQL);
    return getter
      .fetch({}, { context: { headers: { 'x-hasura-role': 'anonymous' } } })
      .pipe(
        tapResponse({
          next: (res) => {
            patchState(store, {
              loading: false,
              data: res.data?.energy_village_feedback,
            });
          },
          error: (error) => {
            patchState(store, {
              loading: false,
              data: undefined,
            });
          },
        }),
      );
  });
};

export const selectType =
  (store: any) => (action: Energy_Village__Tipo_Feedback_Enum) => {
    patchState(store, {
      type: action,
    });
  };
